(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 600px)').matches;
  }

  function bindToggles() {
    document.querySelectorAll('[data-collapse-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        if (!isMobile()) return;
        const col = btn.closest('.fgk__col--collapsible');
        if (!col) return;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  function syncForViewport() {
    document.querySelectorAll('[data-collapse-toggle]').forEach(function (btn) {
      if (!isMobile()) {
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindToggles();
      syncForViewport();
    });
  } else {
    bindToggles();
    syncForViewport();
  }

  window.addEventListener('resize', syncForViewport);
})();

/* ===== GK — Bloco "Pagamento 100% seguro" (carrinho lateral, página do carrinho e rodapé) =====
   Junta num só bloco: Visa, Mastercard, Apple Pay, Google Pay + as logos que já existiam no carrinho
   (MB WAY, PayPal, IBAN, Multibanco, Revolut — imagens das definições do tema). A lista antiga fica escondida.
   Carrinho: todas numa só linha. Rodapé: duas linhas centradas (5 + 4), todas do mesmo tamanho. */
(function () {
  var F = 'font-family="Arial, Helvetica, sans-serif"';
  var APPLE = 'M17.05 12.535c-.026-2.642 2.158-3.913 2.256-3.976-1.231-1.8-3.146-2.046-3.826-2.073-1.628-.165-3.18.96-4.008.96-.83 0-2.108-.937-3.466-.91-1.784.026-3.43 1.039-4.347 2.638-1.855 3.214-.475 7.969 1.331 10.582.882 1.272 1.932 2.704 3.307 2.653 1.327-.053 1.828-.86 3.434-.86 1.604 0 2.06.86 3.464.83 1.43-.026 2.337-1.298 3.21-2.575 1.012-1.482 1.428-2.91 1.454-2.985-.032-.014-2.788-1.07-2.814-4.241zM14.495 4.78c.733-.89 1.227-2.128.092-3.347-.97.04-2.157.65-2.915 1.523-.677.776-1.272 2.024-1.112 3.214 1.086.083 2.2-.55 3.935-1.39z';
  var CARDS = [
    { name: 'Visa', vb: '0 0 40 24', svg: '<text x="20" y="17" text-anchor="middle" ' + F + ' font-size="14" font-weight="900" font-style="italic" fill="#1A1F71">VISA</text>' },
    { name: 'Mastercard', vb: '0 0 34 24', svg: '<circle cx="12" cy="12" r="9" fill="#EB001B"/><circle cx="22" cy="12" r="9" fill="#F79E1B" fill-opacity="0.9"/>' },
    { name: 'Apple Pay', vb: '0 0 44 24', svg: '<path transform="translate(1,2) scale(0.82)" fill="#000" d="' + APPLE + '"/><text x="21" y="17.5" ' + F + ' font-size="13" font-weight="700" fill="#000">Pay</text>' },
    { name: 'Google Pay', vb: '0 0 44 24', svg: '<text x="1" y="17.5" ' + F + ' font-size="13" font-weight="700"><tspan fill="#4285F4">G</tspan><tspan fill="#5f6368" dx="2">Pay</tspan></text>' }
  ];

  function addStyles() {
    if (document.getElementById('gkpay-styles')) return;
    var s = document.createElement('style');
    s.id = 'gkpay-styles';
    s.textContent =
      '.gkcp-payments{display:none !important}' +
      '.gkpay{text-align:center}' +
      '.gkpay__title{margin:0 0 8px;font-size:1.3rem;line-height:1.4}' +
      '.gkpay .gkpay-list{list-style:none;margin:0 auto;padding:0}' +
      '.gkpay .gkpay-list li{margin:0;display:flex;align-items:center;justify-content:center;background:#fff;border:1px solid #d9d9d9;border-radius:4px;line-height:0;box-sizing:border-box;overflow:hidden}' +
      '.gkpay .gkpay-list li img,.gkpay .gkpay-list li svg{display:block !important;width:100% !important;height:100% !important;max-width:100% !important;max-height:100% !important;object-fit:contain !important;margin:0 !important}' +
      /* Carrinho: uma linha só com 9 logos iguais */
      '.gkpay--cart{margin:14px 0 6px}' +
      '.gkpay--cart .gkpay__title{opacity:.8}' +
      '.gkpay--cart .gkpay-list{display:grid;grid-template-columns:repeat(9,minmax(0,1fr));gap:4px;max-width:420px}' +
      '.gkpay--cart .gkpay-list li{height:24px;padding:3px}' +
      /* Rodapé: 2 linhas centradas (5 + 4), cartões do mesmo tamanho */
      '.gkpay--footer{padding:4px 0 20px}' +
      '.gkpay--footer .gkpay__title{font-size:1.2rem;letter-spacing:.06em;text-transform:uppercase;color:#00e1ff;font-weight:700;margin-bottom:10px}' +
      '.gkpay--footer .gkpay-list{display:flex;flex-wrap:wrap;justify-content:center;gap:6px;max-width:320px}' +
      '.gkpay--footer .gkpay-list li{width:58px;height:30px;padding:5px 6px;border-color:#fff}';
    document.head.appendChild(s);
  }

  function buildList() {
    var ul = document.createElement('ul');
    ul.className = 'gkpay-list';
    ul.setAttribute('role', 'list');
    CARDS.forEach(function (i) {
      var li = document.createElement('li');
      li.innerHTML = '<svg viewBox="' + i.vb + '" role="img" aria-label="' + i.name + '" xmlns="http://www.w3.org/2000/svg">' + i.svg + '</svg>';
      ul.appendChild(li);
    });
    var src = document.querySelector('.gkcp-payments');
    if (src) {
      src.querySelectorAll('img').forEach(function (img) {
        var li = document.createElement('li');
        var c = img.cloneNode(true);
        c.removeAttribute('width');
        c.removeAttribute('height');
        c.removeAttribute('loading');
        li.appendChild(c);
        ul.appendChild(li);
      });
    }
    return ul;
  }

  function block(cls, title) {
    var wrap = document.createElement('div');
    wrap.className = 'gkpay ' + cls;
    wrap.innerHTML = '<p class="gkpay__title">' + title + '</p>';
    wrap.appendChild(buildList());
    return wrap;
  }

  function addCart() {
    var anchors = [];
    document.querySelectorAll('.cart__ctas').forEach(function (c) { anchors.push(c); });
    document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      if (!b.closest('.cart__ctas') && b.parentElement) anchors.push(b.parentElement);
    });
    anchors.forEach(function (a) {
      if (!a.parentNode) return;
      var next = a.nextElementSibling;
      if (next && next.classList.contains('gkpay--cart')) return;
      a.parentNode.insertBefore(block('gkpay--cart', '🔒 Pagamento 100% seguro'), a.nextSibling);
    });
  }

  function addFooter() {
    var f = document.querySelector('footer.fgk');
    if (!f || f.querySelector('.gkpay--footer')) return;
    var el = block('gkpay--footer', '🔒 Pagamento 100% seguro');
    var bottom = f.querySelector('.fgk__bottom');
    if (bottom) bottom.parentNode.insertBefore(el, bottom);
    else f.appendChild(el);
  }

  function run() {
    addStyles();
    addCart();
    addFooter();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }

  function init() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
